var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('MainSlider'),_c('MainDescription'),_c('ServicesPresentation'),_c('MainServices'),_c('VideoConcrete'),_c('BannerWeLove'),_c('Testimonials'),_c('MainGallery')],1)}
var staticRenderFns = []

export { render, staticRenderFns }